export function cn(...classes) {
    return classes.filter(Boolean).join(' ');
}
export function workTypeLabel(workType) {
    switch (workType) {
        case 1: return 'Movie';
        case 2: return 'Series';
        case 3: return 'Season';
        case 4: return 'Episode';
        default: return 'Unknown';
    }
}
const TMDB_IMAGE_BASE = 'https://image.tmdb.org/t/p';
export function tmdbImage(path, size = 'w500') {
    if (!path)
        return undefined;
    if (path.startsWith('http'))
        return path;
    return `${TMDB_IMAGE_BASE}/${size}${path}`;
}
export function parsePayload(raw) {
    if (!raw)
        return {};
    try {
        return JSON.parse(raw);
    }
    catch {
        return {};
    }
}
